import { render, staticRenderFns } from "./EmployerGroupDetail.vue?vue&type=template&id=07b31f1c&"
import script from "./EmployerGroupDetail.vue?vue&type=script&lang=js&"
export * from "./EmployerGroupDetail.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/employer-groups.css?vue&type=style&index=0&lang=css&"
import style1 from "./EmployerGroupDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports